const getDefaultState = () => {
  return {
    sensors: [],
    sensor: null,
    userSensors: [],
    temperatureChart: [],
    humidityChart: [],
    pressureChart: [],
    aqiChart: [],
    pm1Chart: [],
    pm2_5Chart: [],
    pm4Chart: [],
    pm10Chart: [],
    covChart: [],
    co2Chart: [],
  };
};

export default {
  SET_SENSORS: (state, sensors) => (state.sensors = sensors),
  SET_SENSOR_ITEM: (state, sensor) => (state.sensor = sensor),
  SET_USER_SENSORS: (state, sensors) => (state.userSensors = sensors),
  SET_SENSOR(state, sensor) {
    state.sensors.splice(
      state.sensors.findIndex((s) => s.macAddress == sensor.macAddress),
      1,
      sensor
    );
  },
  SET_TEMPERATURE_CHART: (state, temperature) =>
    (state.temperatureChart = temperature),
  SET_HUMIDITY_CHART: (state, humidity) => (state.humidityChart = humidity),
  SET_PRESSURE_CHART: (state, pressure) => (state.pressureChart = pressure),
  SET_AQI_CHART: (state, aqi) => (state.aqiChart = aqi),
  SET_PM1_CHART: (state, pm1) => (state.pm1Chart = pm1),
  SET_PM2_5_CHART: (state, pm2_5) => (state.pm2_5Chart = pm2_5),
  SET_PM4_CHART: (state, pm4) => (state.pm4Chart = pm4),
  SET_PM10_CHART: (state, pm10) => (state.pm10Chart = pm10),
  SET_COV_CHART: (state, cov) => (state.covChart = cov),
  SET_CO2_CHART: (state, co2) => (state.co2Chart = co2),
  RESET_STATE: (state) => Object.assign(state, getDefaultState()),
};
